<template>
  <div :class="{ 'd-flex': horizontal }">
    <v-checkbox
      class="mt-2 mr-4"
      density="compact"
      v-for="day in weekdays"
      :key="`${day}-checkbox`"
      color="primary"
      :hide-details="true"
      :disabled="day === disabledDay"
      v-model="checkedDays"
      :value="day">
      <template v-slot:label>
        <span class="font-size-small">{{ getLabel(day) }}</span>
      </template>
    </v-checkbox>
  </div>
</template>

<script>
import { Info } from 'luxon';

export default {
  props: {
    modelValue: {
      type: Array,
      required: false,
      default() {
        return [];
      }
    },
    /**
     * If provided, this will disable the checkbox for specific weekday
     */
    disabledDay: {
      type: String,
      required: false
    },
    horizontal: {
      type: Boolean,
      required: false
    },
    shortNames: {
      type: Boolean,
      required: false
    },
    sundayFirst: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    /**
     * array of lowercase weekdays ["sunday", "monday"...]
     */
    weekdays() {
      const weekdays = Info.weekdays();
      const orderedWeekdays = this.sundayFirst
        ? [weekdays[weekdays.length - 1], ...weekdays.slice(0, -1)]
        : weekdays;
      return orderedWeekdays.map(weekday => weekday.toLowerCase());
    }
  },
  data() {
    return {
      checkedDays: this.modelValue ?? []
    };
  },
  methods: {
    getLabel(day) {
      let weekDay = day.toLowerCase();
      weekDay = this.shortNames ? weekDay.substring(0, 3) : weekDay;
      return this.shortNames
        ? this.$t(`global.weekdaysAbbr.${weekDay.toLowerCase()}`)
        : this.$t(`global.weekdays.${weekDay.toLowerCase()}`);
    }
  },
  mounted() {
    this.checkedDays = this.modelValue ?? [];
  },
  watch: {
    checkedDays(checkedDays) {
      this.$emit('update:model-value', checkedDays);
    }
  }
};
</script>
